import React from 'react';
import DetailFrame from '../components/Detail/DetailFrame';

const DetailPage = () => {
  return <DetailFrame />;
};

export default DetailPage;
